/* eslint-disable @typescript-eslint/no-explicit-any */
import { Platform } from 'react-native';

export const isDesktop = (): boolean => {
  // Wails v2 detection - check for go.main.App bindings
  return (
    typeof window !== 'undefined' &&
    typeof (window as any).go !== 'undefined' &&
    typeof (window as any).go.main !== 'undefined' &&
    typeof (window as any).go.main.App !== 'undefined'
  );
};

// Web is the opposite of desktop and it is not android or iOS
export const isWeb = (): boolean => {
  return !isDesktop() && !isMobile();
};

export const isMobile = (): boolean =>
  Platform.OS === 'android' || Platform.OS === 'ios';
